exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-toolbar__title[data-v-5503154c] {\n    white-space: normal !important;\n}\n", ""]);

